import React from 'react';
import { Form, Grid, Dropdown, Icon, Header, Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  timeZoneDropdownOptions,
  MODAL_CHECK_BOX_LABEL_STYLE,
  MODAL_CHECK_BOX_STYLE,
  MIN_SCHEDULE_FREQUENCY,
  PUBLISH_AS_PLANNED_OPTIONS,
} from '../../../HelperMethods/constants';

import { getPickListOptions } from '../../../HelperMethods/UtilityFunctions';

const PUBLISH_AS_PLANNED_DROPDOWN_OPTIONS = getPickListOptions(PUBLISH_AS_PLANNED_OPTIONS);

const EngineScheduler = function ({
  scheduleParams,
  onScheduleParamsInputChange,
  errors,
  updateError,
  validateMinutesStep,
}) {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <Header size="small">Engine Scheduler</Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field
            inline
            style={{
              cursor: 'pointer',
            }}
            onClick={() => {
              onScheduleParamsInputChange('enabled', !scheduleParams.enabled);
            }}
          >
            {scheduleParams.enabled ? (
              <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
            ) : (
              <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
            )}
            <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Active</label>
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field inline>
            <label>Schedule Name</label>
            <input
              type="text"
              value={scheduleParams.name}
              name="name"
              onChange={(event) => {
                onScheduleParamsInputChange(event.target.name, event.target.value);
              }}
            />
            {errors.name && <div className="errorText modal-error-text">*{errors.name}</div>}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field inline>
            <label>Select Area(s)</label>
            <Dropdown
              clearable
              fluid
              search
              multiple
              selection
              options={scheduleParams.areasDropDown}
              value={scheduleParams.areaIds}
              onChange={(event, data) => {
                onScheduleParamsInputChange(data.name, data.value);
              }}
              name="areaIds"
            />
            {errors.areaIds && <div className="errorText modal-error-text">*{errors.areaIds}</div>}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field inline>
            <label>Select Days(s)</label>
            <Dropdown
              clearable
              fluid
              search
              multiple
              selection
              options={scheduleParams.selectedDaysDropDown}
              value={scheduleParams.selectedDays}
              onChange={(event, data) => {
                onScheduleParamsInputChange(data.name, data.value);
              }}
              name="selectedDays"
            />
            {errors.selectedDays && <div className="errorText modal-error-text">*{errors.selectedDays}</div>}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field inline>
            <label>Publish as Planned For</label>
            <Dropdown
              clearable
              fluid
              search
              selection
              options={PUBLISH_AS_PLANNED_DROPDOWN_OPTIONS}
              value={scheduleParams.publishAsPlanned}
              onChange={(event, data) => {
                onScheduleParamsInputChange(data.name, data.value);
              }}
              name="publishAsPlanned"
            />
            {errors.publishAsPlanned && <div className="errorText modal-error-text">*{errors.publishAsPlanned}</div>}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field inline>
            <label>Time Zone</label>
            <Dropdown
              clearable
              fluid
              search
              selection
              options={timeZoneDropdownOptions}
              value={scheduleParams.timeZone}
              onChange={(event, data) => {
                onScheduleParamsInputChange(data.name, data.value);
              }}
              name="timeZone"
            />
            {errors.timeZone && <div className="errorText modal-error-text">*{errors.timeZone}</div>}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Form.Field
            inline
            style={{
              cursor: 'pointer',
            }}
            onClick={() => {
              onScheduleParamsInputChange('runOnFixedTime', !scheduleParams.runOnFixedTime);
            }}
          >
            {scheduleParams.runOnFixedTime ? (
              <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
            ) : (
              <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
            )}
            <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Run on Fixed Time</label>
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      {scheduleParams.runOnFixedTime && (
        <Grid.Row columns={2}>
          <Grid.Column width={12}>
            <Form.Field>
              <label>Add a Fixed Time</label>
              <input
                type="time"
                value={scheduleParams.fixedTimeVariable}
                name="fixedTimeVariable"
                step={MIN_SCHEDULE_FREQUENCY * 60}
                onChange={(event) => {
                  onScheduleParamsInputChange(event.target.name, event.target.value);
                }}
              />
              {errors.fixedTimeList && <div className="errorText modal-error-text">*{errors.fixedTimeList}</div>}
            </Form.Field>
          </Grid.Column>
          <Grid.Column width={2}>
            <Icon
              name="add"
              style={{ position: 'relative', top: '35px', cursor: 'pointer' }}
              onClick={() => {
                if (scheduleParams.fixedTimeVariable) {
                  const minutes = scheduleParams.fixedTimeVariable.split(':')[1];
                  if (validateMinutesStep(minutes)) {
                    scheduleParams.fixedTimeList.push(scheduleParams.fixedTimeVariable);
                    onScheduleParamsInputChange('fixedTimeList', scheduleParams.fixedTimeList);
                    updateError('fixedTimeList', '');
                    onScheduleParamsInputChange('fixedTimeVariable', '');
                  } else {
                    updateError('fixedTimeList', `${MIN_SCHEDULE_FREQUENCY} mins is minimum step`);
                  }
                }
              }}
            />
          </Grid.Column>
        </Grid.Row>
      )}
      {scheduleParams.runOnFixedTime && scheduleParams.fixedTimeList.length > 0 && (
        <Grid.Row>
          <Grid.Column>
            <Label.Group>
              {scheduleParams.fixedTimeList.map((time, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <Label key={index} as="span" className="label-group-label">
                    {time}
                    <Icon
                      name="delete"
                      onClick={() => {
                        scheduleParams.fixedTimeList.splice(index, 1);
                        onScheduleParamsInputChange('fixedTimeList', scheduleParams.fixedTimeList);
                      }}
                    />
                  </Label>
                );
              })}
            </Label.Group>
          </Grid.Column>
        </Grid.Row>
      )}
      {!scheduleParams.runOnFixedTime && (
        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Field>
              <label>Frequency Hour</label>
              <input
                type="number"
                value={scheduleParams.frequencyHour}
                name="frequencyHour"
                onChange={(event) => {
                  const value = event.target.value ? parseInt(event.target.value, 10) : '';
                  onScheduleParamsInputChange(event.target.name, value);
                }}
              />
              {errors.frequencyHour && <div className="errorText modal-error-text">*{errors.frequencyHour}</div>}
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <label>Frequency Minutes</label>
              <input
                type="number"
                value={scheduleParams.frequencyMinutes}
                max="59"
                name="frequencyMinutes"
                onChange={(event) => {
                  const value = event.target.value ? parseInt(event.target.value, 10) : '';
                  onScheduleParamsInputChange(event.target.name, value);
                }}
              />
              {errors.frequencyMinutes && <div className="errorText modal-error-text">*{errors.frequencyMinutes}</div>}
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
      )}
      {!scheduleParams.runOnFixedTime && (
        <Grid.Row columns={2}>
          <Grid.Column>
            <Form.Field>
              <label>Frequency Start Time</label>
              <input
                type="time"
                value={scheduleParams.frequencyStartTime}
                step={MIN_SCHEDULE_FREQUENCY * 60}
                name="frequencyStartTime"
                onChange={(event) => {
                  onScheduleParamsInputChange(event.target.name, event.target.value);
                }}
              />
              {errors.frequencyStartTime && (
                <div className="errorText modal-error-text">*{errors.frequencyStartTime}</div>
              )}
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <label>Frequency End Time</label>
              <input
                type="time"
                value={scheduleParams.frequencyEndTime}
                step={MIN_SCHEDULE_FREQUENCY * 60}
                name="frequencyEndTime"
                onChange={(event) => {
                  onScheduleParamsInputChange(event.target.name, event.target.value);
                }}
              />
              {errors.frequencyEndTime && <div className="errorText modal-error-text">*{errors.frequencyEndTime}</div>}
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};
EngineScheduler.propTypes = {
  scheduleParams: PropTypes.object.isRequired,
  onScheduleParamsInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  updateError: PropTypes.func.isRequired,
  validateMinutesStep: PropTypes.func.isRequired,
};
export default EngineScheduler;
